import { Grid } from "@material-ui/core";
import React, { FunctionComponent } from "react";

export const AppLayoutFooter: FunctionComponent = ({ children }) => (
  <Grid item xs={10} style={{backgroundColor:"#fff"}}>
    {children}
  </Grid>
);
